import { avgWatchTime } from './avg-watch-time';
import { medianWatchTime } from './median-watch-time';
import { newReturnViewers } from './new-return-viewers';
import { peakConcurrentViewers } from './peak-concurrent-viewers';
import { totalTimeWatched } from './total-time-watched';
import { views } from './views';

export const kpis = {
  avgWatchTime,
  medianWatchTime,
  newReturnViewers,
  peakConcurrentViewers,
  totalTimeWatched,
  views,
};
